import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsPlanEntryRelatedTaxiTaxi from "./billings-plan-entry-related-taxi-taxi";
import BillingsPlanEntryRelatedTaxiTaxiParams from "./billings-plan-entry-related-taxi-taxi-params";

const useBillingsPlanEntryRelatedTaxiTaxi = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsPlanEntryRelatedTaxiTaxi>({
      data: [],
    });

  const load = async (
    params: BillingsPlanEntryRelatedTaxiTaxiParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const taxiTaxi = await billingService.getPlanEntryRelatedTaxiTaxiBillings(
        params,
        signal,
      );

      setData(taxiTaxi);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsPlanEntryRelatedTaxiTaxi;
